// extracted by mini-css-extract-plugin
module.exports = {"textarea-container":"CallNotesForm_textarea-container__5SHAr","hasError":"CallNotesForm_hasError__24n6a","label":"CallNotesForm_label__XlKiQ"};